import React, { Component } from 'react';
import {
  getAccountSigner,
  getWeb3Provider,
  addMetamaskListeners,
  isMetamaskConnected,
  getMetamaskProvider,
  getAccountEthBalance,
  formatUnits,
  getAccountZutBalance,
  getERC721Token,
  multiSendERC721ETH,
  multiSendERC721ZUT,
  connectToMetamask,
  approveMultisendContractAsOperator,
  isApprovedMultisendContractAsOperator,
  getERC1155Token,
  getERC1155TokenUri,
  multiSendERC1155ETH,
  multiSendERC1155ZUT,
  adminWithdrawETH,
  adminWithdrawZUT,
  getNFTMultisendETHBalance,
  getNFTMultisendZUTBalance,
  getNFTMultisendETHFees,
  getNFTMultisendZUTFees,
  setNFTMultisendETHFees,
  setNFTMultisendZUTFees,
  queryAccountERC1155Tokens,
  getERC20Token,
  isApprovedERC20,
  multiSendERC20ETH,
  multiSendERC20ZUT,
} from '../../apis/blockchain';
import { PAYMENT_OPTION, TOKEN_TYPE, ADMIN_ADDRESS } from '../../constants';

import Header from '../Header/Header';
import MultiSendInfo from '../MultiSendInfo/MultiSendInfo';
import TransferInfo from '../TransferInfo/TransferInfo';
import ConnectionBanner from '@rimble/connection-banner';
import { Button, Heading, Box, Flex, Modal, Text, Card } from 'rimble-ui';
import AdminSection from '../AdminSection/AdminSection';

class MainAppContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tokenType: TOKEN_TYPE.ERC20,
      paymentOption: PAYMENT_OPTION.ETH,

      tokenContract: {},
      tokenName: null,
      tokenSymbol: null,
      tokenAmt: null,
      tokenAddressLoading: false,
      tokenAddressError: false,

      receiversAndIds: [],
      sendTokensLoading: false,
      sendTokensError: false,
      sendTokensErrorType: '',
      errorTokenIds: [],

      metamaskProvider: null,
      web3Provider: null,
      metamaskInstalled: true,
      metamaskConnected: true,

      networkId: 1,
      currentAccountAddress: '',
      accountEthAmount: 0,
      accountZutAmount: 0,

      tokenAddressInputVal: '',

      receiversAndIdsInputVal: '',

      isOpen: false,
      warningConfirmed: false,

      approvedAsOperator: false,
      approvedAsOperatorLoading: false,

      erc1155TokenUri: '',

      nftMultisendEthBalance: 0,
      nftMultisendZutBalance: 0,
      adminWithdrawLoading: false,

      feesEth: 0,
      feesZut: 0,
      setFeesLoading: false,

      ethFeesInputVal: '0',
      zutFeesInputVal: '0',

      ownedERC1155Tokens: [],
      maxERC1155TokenId: 10000,
      tokenMaxIdInputVal: '',
      ownedERC1155TokensLoading: false,

      ERC20Decimals: '18',
    };
  }

  async componentDidMount() {
    let metamaskProvider = await getMetamaskProvider();
    let web3Provider = await getWeb3Provider(metamaskProvider);
    console.log('signer', web3Provider.getSigner());

    if (metamaskProvider && web3Provider) {
      addMetamaskListeners(
        metamaskProvider,
        async (chainId) => {
          this.setState({
            networkId: parseInt(chainId),
          });
        },
        (message) => {},
        async (accounts) => {
          if (accounts.length === 0) {
            this.setState({ metamaskConnected: false });
          } else if (accounts[0] !== this.state.currentAccountAddress) {
            this.setState({
              metamaskConnected: true,
              currentAccountAddress: accounts[0],
              accountEthAmount: formatUnits(
                await getAccountEthBalance(web3Provider, accounts[0])
              ),
              accountZutAmount: formatUnits(
                await getAccountZutBalance(web3Provider, accounts[0])
              ),
            });
          }
        }
      );

      let currentAccountAddress;
      try {
        currentAccountAddress = await (
          await getAccountSigner(web3Provider)
        ).getAddress();
      } catch (error) {
        currentAccountAddress = '';
      }

      let accountEthAmount;
      try {
        accountEthAmount = formatUnits(
          await getAccountEthBalance(web3Provider, currentAccountAddress)
        );
      } catch (error) {
        accountEthAmount = 0;
      }

      let accountZutAmount;
      try {
        accountZutAmount = formatUnits(
          await getAccountZutBalance(web3Provider, currentAccountAddress)
        );
      } catch (error) {
        accountZutAmount = 0;
      }

      let nftMultisendEthBalance;
      try {
        nftMultisendEthBalance = formatUnits(
          await getNFTMultisendETHBalance(web3Provider)
        );
      } catch (error) {
        nftMultisendEthBalance = 0;
      }

      let nftMultisendZutBalance;
      try {
        nftMultisendZutBalance = formatUnits(
          await getNFTMultisendZUTBalance(web3Provider)
        );
      } catch (error) {
        nftMultisendZutBalance = 0;
      }

      let feesEth;
      try {
        feesEth = formatUnits(await getNFTMultisendETHFees(web3Provider));
      } catch (error) {
        feesEth = 0;
      }

      let feesZut;
      try {
        feesZut = formatUnits(await getNFTMultisendZUTFees(web3Provider));
      } catch (error) {
        feesZut = 0;
      }

      this.setState({
        web3Provider,
        metamaskProvider,
        metamaskConnected: await isMetamaskConnected(metamaskProvider),
        networkId: parseInt(window.ethereum.chainId),
        currentAccountAddress: currentAccountAddress,
        accountEthAmount: accountEthAmount,
        accountZutAmount: accountZutAmount,
        nftMultisendEthBalance: nftMultisendEthBalance,
        nftMultisendZutBalance: nftMultisendZutBalance,
        feesEth: feesEth,
        feesZut: feesZut,
        ethFeesInputVal: feesEth.toString(),
        zutFeesInputVal: feesZut.toString(),
      });
    } else {
      this.setState({
        metamaskInstalled: false,
        metamaskConnected: false,
      });
    }
  }

  async componentDidUpdate() {
    if (
      this.state.tokenType !== TOKEN_TYPE.ERC20 &&
      !this.state.warningConfirmed &&
      !this.state.isOpen &&
      this.state.tokenAmt / 10 ** 16 > 1
    )
      this.openModal();
  }

  closeWarningModal = () => {
    this.setState({ isOpen: false, warningConfirmed: true });
  };

  openWarningModal = () => {
    this.setState({ isOpen: true });
  };

  closeModal = () => {
    //e.preventDefault();
    this.closeWarningModal();
  };

  openModal = () => {
    //e.preventDefault();
    this.openWarningModal();
  };

  loadToken = async () => {
    this.setState({ tokenAddressLoading: true, tokenAddressError: false });
    try {
      let tokenContract;
      let ownedERC1155Tokens;
      if (this.state.tokenType === TOKEN_TYPE.ERC20) {
        tokenContract = await getERC20Token(
          this.state.web3Provider,
          this.state.tokenAddressInputVal
        );
        console.log('decimals', (await tokenContract.decimals()).toString());
        this.setState({
          tokenAddressLoading: false,
          tokenAddressError: false,
          tokenContract: tokenContract,
          tokenSymbol: await tokenContract.symbol(),
          tokenName: await tokenContract.name(),
          tokenAmt: await tokenContract.balanceOf(
            this.state.currentAccountAddress
          ),
          approvedAsOperator: await isApprovedERC20(
            tokenContract,
            this.state.currentAccountAddress
          ),
          warningConfirmed: false,
          ERC20Decimals: (await tokenContract.decimals()).toString(),
        });
      } else if (this.state.tokenType === TOKEN_TYPE.ERC721) {
        tokenContract = await getERC721Token(
          this.state.web3Provider,
          this.state.tokenAddressInputVal
        );
        this.setState({
          tokenAddressLoading: false,
          tokenAddressError: false,
          tokenContract: tokenContract,
          tokenSymbol: await tokenContract.symbol(),
          tokenName: await tokenContract.name(),
          tokenAmt: await tokenContract.balanceOf(
            this.state.currentAccountAddress
          ),
          approvedAsOperator: await isApprovedMultisendContractAsOperator(
            tokenContract,
            this.state.currentAccountAddress
          ),
          warningConfirmed: false,
        });
      } else {
        tokenContract = await getERC1155Token(
          this.state.web3Provider,
          this.state.tokenAddressInputVal
        );

        ownedERC1155Tokens = await queryAccountERC1155Tokens(
          tokenContract,
          this.state.currentAccountAddress,
          0,
          this.state.maxERC1155TokenId
        );

        this.setState({
          tokenAddressLoading: false,
          tokenAddressError: false,
          tokenContract: tokenContract,
          tokenSymbol: 'ERC1155',
          tokenName: 'ERC1155',
          tokenAmt: 0,
          erc1155TokenUri: await getERC1155TokenUri(
            this.state.web3Provider,
            tokenContract.address
          ),
          approvedAsOperator: await isApprovedMultisendContractAsOperator(
            tokenContract,
            this.state.currentAccountAddress
          ),
          warningConfirmed: false,
          ownedERC1155Tokens,
        });
      }
    } catch (e) {
      this.setState({
        tokenAddressLoading: false,
        tokenAddressError: true,
        tokenContract: {},
        tokenSymbol: null,
        tokenName: null,
        tokenAmt: null,
        warningConfirmed: false,
      });
    }
  };

  approveSmartContract = async () => {
    this.setState({ approvedAsOperatorLoading: true });
    await approveMultisendContractAsOperator(
      this.state.tokenType,
      this.state.tokenContract,
      () => {
        this.setState({
          approvedAsOperatorLoading: false,
          approvedAsOperator: true,
        });
      }
    );
  };

  sendTokens = async (callback) => {

    this.setState({ sendTokensLoading: true, sendTokensError: false });
    let unparsedreceiversAndIds = this.state.receiversAndIdsInputVal.split(
      '\n'
    );
    while (
      unparsedreceiversAndIds[unparsedreceiversAndIds.length - 1] === '' ||
      unparsedreceiversAndIds[unparsedreceiversAndIds.length - 1] === '\n' ||
      unparsedreceiversAndIds === undefined
    )
      unparsedreceiversAndIds.pop();

    let receivingAddresses = [];
    let tokenIds = [];
    let tokenAmounts = [];
    if (this.state.tokenType === TOKEN_TYPE.ERC721) {
      for (let i = 0; i < unparsedreceiversAndIds.length; i++) {
        let pair = unparsedreceiversAndIds[i].split(',');
        receivingAddresses.push(pair[0]);
        tokenIds.push(pair[1]);
      }
    } else if (this.state.tokenType === TOKEN_TYPE.ERC1155) {
      for (let i = 0; i < unparsedreceiversAndIds.length; i++) {
        let group = unparsedreceiversAndIds[i].split(',');
        receivingAddresses.push(group[0]);
        tokenIds.push(group[1]);
        tokenAmounts.push(group[2]);
      }
    } else if (this.state.tokenType === TOKEN_TYPE.ERC20) {
      for (let i = 0; i < unparsedreceiversAndIds.length; i++) {
        let group = unparsedreceiversAndIds[i].split(',');
        receivingAddresses.push(group[0]);
        tokenAmounts.push(group[1]);
      }
    }

    //console.log('tokenIds', tokenIds[0], tokenIds[0].length);
    console.log('send token', { receivingAddresses, tokenAmounts });

    let errorTokenIds;
    try {
      let result;
      if (this.state.tokenType === TOKEN_TYPE.ERC20) {
        if (this.state.paymentOption === PAYMENT_OPTION.ETH) {
          result = await multiSendERC20ETH(
            this.state.web3Provider,
            this.state.tokenContract,
            receivingAddresses,
            this.state.currentAccountAddress,
            tokenAmounts
          );
        } else {
          result = await multiSendERC20ZUT(
            this.state.web3Provider,
            this.state.tokenContract,
            receivingAddresses,
            this.state.currentAccountAddress,
            tokenAmounts
          );
        }
      } else if (this.state.tokenType === TOKEN_TYPE.ERC721) {
        if (this.state.paymentOption === PAYMENT_OPTION.ETH) {
          result = await multiSendERC721ETH(
            this.state.web3Provider,
            this.state.tokenContract,
            receivingAddresses,
            this.state.currentAccountAddress,
            tokenIds
          );
        } else {
          result = await multiSendERC721ZUT(
            this.state.web3Provider,
            this.state.tokenContract,
            receivingAddresses,
            this.state.currentAccountAddress,
            tokenIds
          );
        }
      } else if (this.state.tokenType === TOKEN_TYPE.ERC1155) {
        if (this.state.paymentOption === PAYMENT_OPTION.ETH) {
          result = await multiSendERC1155ETH(
            this.state.web3Provider,
            this.state.tokenContract,
            receivingAddresses,
            this.state.currentAccountAddress,
            tokenIds,
            tokenAmounts
          );
        } else {
          result = await multiSendERC1155ZUT(
            this.state.web3Provider,
            this.state.tokenContract,
            receivingAddresses,
            this.state.currentAccountAddress,
            tokenIds,
            tokenAmounts
          );
        }
      }

      if (result.type === 'INVALID_TOKENS') {
        errorTokenIds = result.errorTokenIds;
        throw new Error('INVALID_TOKENS');
      } else if (result.type === 'INSUFFICIENT_BALANCE') {
        throw new Error('INSUFFICIENT_BALANCE');
      }
      callback(result.tx.hash);
      this.setState({
        sendTokensLoading: false,
        sendTokensError: false,
        sendTokensErrorType: '',
        errorTokenIds: [],
        sendTokensTx: result.tx,
      });
    } catch (e) {
      console.error(e);
      
      this.setState({
        sendTokensLoading: false,
        sendTokensError: true,
        sendTokensErrorType: e.message,
        errorTokenIds,
      });
    }
  };

  render() {
    return (
      <>
        {!this.state.metamaskInstalled ? (
          <ConnectionBanner
            currentNetwork={this.state.networkId}
            requiredNetwork={1}
            onWeb3Fallback={true}
          />
        ) : null}
        <Header
          isMetamaskConnected={
            this.state.metamaskConnected &&
            this.state.currentAccountAddress !== ''
          }
          connectToMetamask={() => {
            connectToMetamask(this.state.metamaskProvider);
          }}
          networkId={this.state.networkId}
          ethAddress={this.state.currentAccountAddress}
        />
        {this.state.currentAccountAddress === ADMIN_ADDRESS ? (
          <AdminSection
            adminWithdrawETH={async () => {
              this.setState({ adminWithdrawLoading: true });
              await adminWithdrawETH(this.state.web3Provider);
              this.setState({ adminWithdrawLoading: false });
            }}
            adminWithdrawZUT={async () => {
              this.setState({ adminWithdrawLoading: true });
              await adminWithdrawZUT(this.state.web3Provider);
              this.setState({ adminWithdrawLoading: false });
            }}
            adminWithdrawLoading={this.state.adminWithdrawLoading}
            eth={this.state.nftMultisendEthBalance}
            zut={this.state.nftMultisendZutBalance}
            ethFeesInputVal={this.state.ethFeesInputVal}
            zutFeesInputVal={this.state.zutFeesInputVal}
            onChangeEthFeesInputVal={(newVal) => {
              this.setState({ ethFeesInputVal: newVal });
            }}
            onChangeZutFeesInputVal={(newVal) => {
              this.setState({ zutFeesInputVal: newVal });
            }}
            setNFTMultisendETHFees={async () => {
              this.setState({ setFeesLoading: true });
              await setNFTMultisendETHFees(
                this.state.web3Provider,
                this.state.ethFeesInputVal
              );
              this.setState({ setFeesLoading: false });
            }}
            setNFTMultisendZUTFees={async () => {
              this.setState({ setFeesLoading: true });
              await setNFTMultisendZUTFees(
                this.state.web3Provider,
                this.state.zutFeesInputVal
              );
              this.setState({ setFeesLoading: false });
            }}
          />
        ) : null}

        {this.state.metamaskInstalled &&
        this.state.metamaskConnected &&
        this.state.currentAccountAddress !== '' ? (
          <>
            <MultiSendInfo
              tokenType={this.state.tokenType}
              changeTokenType={(tokenType) => {
                this.setState({
                  tokenType: tokenType,
                });
              }}
              paymentOption={this.state.paymentOption}
              changePaymentOption={(paymentOption) => {
                this.setState({
                  paymentOption: paymentOption,
                });
              }}
              accountEthAmount={this.state.accountEthAmount}
              accountZutAmount={this.state.accountZutAmount}
              feesEth={this.state.feesEth}
              feesZut={this.state.feesZut}
            />

            <TransferInfo
              tokenType={this.state.tokenType}
              tokenAddressLoading={this.state.tokenAddressLoading}
              tokenAddressError={this.state.tokenAddressError}
              onChangeTokenAddressInputVal={(newTokenAddressValue) => {
                this.setState({
                  tokenAddressInputVal: newTokenAddressValue,
                });
              }}
              tokenAddressInputVal={this.state.tokenAddressInputVal}
              loadToken={this.loadToken}
              tokenName={this.state.tokenName}
              tokenSymbol={this.state.tokenSymbol}
              tokenAmt={
                this.state.tokenAmt !== null
                  ? this.state.tokenAmt.toString()
                  : null
              }
              erc1155TokenUri={this.state.erc1155TokenUri}
              sendTokensLoading={this.state.sendTokensLoading}
              sendTokensError={this.state.sendTokensError}
              sendTokensErrorType={this.state.sendTokensErrorType}
              sendTokens={this.sendTokens}
              approvedAsOperator={this.state.approvedAsOperator}
              //approvedAsOperator={true}
              approvedAsOperatorLoading={this.state.approvedAsOperatorLoading}
              approveSmartContract={this.approveSmartContract}
              receiversAndIdsInputVal={this.state.receiversAndIdsInputVal}
              onChangereceiversAndIdsInputVal={(newValue) => {
                this.setState({
                  receiversAndIdsInputVal: newValue,
                });
              }}
              ownedERC1155TokensLoading={this.state.ownedERC1155TokensLoading}
              ownedERC1155Tokens={this.state.ownedERC1155Tokens}
              maxERC1155TokenId={this.state.maxERC1155TokenId}
              onChangeTokenMaxIdInputVal={(newValue) => {
                this.setState({
                  tokenMaxIdInputVal: newValue,
                });
              }}
              queryAccountERC1155Tokens={async () => {
                this.setState({ ownedERC1155TokensLoading: true });
                let ownedERC1155Tokens = await queryAccountERC1155Tokens(
                  this.state.tokenContract,
                  this.state.currentAccountAddress,
                  parseInt(this.state.tokenMaxIdInputVal) - 10000 > 0
                    ? parseInt(this.state.tokenMaxIdInputVal) - 10000
                    : 0,
                  parseInt(this.state.tokenMaxIdInputVal)
                );
                this.setState({
                  ownedERC1155TokensLoading: false,
                  ownedERC1155Tokens,
                  maxERC1155TokenId: parseInt(this.state.tokenMaxIdInputVal),
                });
              }}
            />
          </>
        ) : null}

        <Modal isOpen={this.state.isOpen}>
          <Card width={'420px'} p={0}>
            <Button.Text
              icononly
              icon={'Close'}
              color={'moon-gray'}
              position={'absolute'}
              top={0}
              right={0}
              mt={3}
              mr={3}
              onClick={this.closeModal}
            />

            <Box p={4} mb={3}>
              <Heading.h3>Warning</Heading.h3>
              <Text>
                This token seems to have a large supply. Double check that this
                token is ERC721 or ERC1155 and not ERC20.
              </Text>
            </Box>

            <Flex
              px={4}
              py={3}
              borderTop={1}
              borderColor={'#E8E8E8'}
              justifyContent={'flex-end'}
            >
              <Button.Outline onClick={this.closeModal}>Got it!</Button.Outline>
            </Flex>
          </Card>
        </Modal>
      </>
    );
  }
}

export default MainAppContainer;
